<script lang="ts">
import SelectableButton from "@/Components/Generics/SelectableButton.vue";
import MainPage from "@/Components/MainPage.vue";
import AppLayout from "@/Layouts/App.vue";
import { QualificationGroup, QualificationsGroups } from "@/Types";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    components: {
        MainPage,
        SelectableButton,
    },
    layout: AppLayout,
    props: {
        qualificationGroups: {
            type: Array as PropType<QualificationsGroups>,
            required: true,
        },
    },
    data: () => ({
        selectedGroupId: null as number,
    }),
    computed: {
        selectedGroup(): QualificationGroup {
            return this.qualificationGroups.find((qg) => qg.id === this.selectedGroupId);
        },
    },
    mounted() {
        this.selectedGroupId = this.qualificationGroups[0].id;
    },
});
</script>

<template>
    <MainPage :title="$trans('navigation.nav_qualifications')" title-id="qualifications-page" :gap="true">
        <div class="qualifications-wrapper flex flex--width flex--v flex--valign-c flex--gap-50">
            <div class="qualifications-buttons flex flex--width flex--halign-c flex--wrap flex--gap-10">
                <SelectableButton
                    v-for="group in qualificationGroups"
                    :key="group.id"
                    :title="$trans('qualifications.' + group.name).toUpperCase()"
                    :circular="true"
                    :primary="true"
                    :selected="selectedGroupId === group.id"
                    @click="selectedGroupId = group.id" />
            </div>

            <Transition name="generic-fade" mode="out-in">
                <div v-if="selectedGroup" :key="selectedGroupId" class="qualifications-info-wrapper flex flex--v flex--valign-c flex--gap-50">
                    <div v-for="qualification in selectedGroup.qualifications" :key="qualification.id" class="qualifications-info flex flex--v flex--valign-c flex--gap-15">
                        <span class="qualfications-info-text text text--uppercase text--primary-b text--size-22 text--semi-bold text--center">
                            {{ $trans("qualifications." + qualification.name) }}
                        </span>
                        <span class="qualfications-info-text text text--accent-gray-b text--size-20 text--height-24 text--medium text--center">
                            {{ $trans("qualifications." + qualification.name + "_description") }}
                        </span>
                    </div>
                </div>
            </Transition>
        </div>
    </MainPage>
</template>

<style lang="scss" scoped>
.qualifications-wrapper {
    .qualifications-buttons {
        max-width: 80%;
    }

    .qualifications-info-wrapper {
        .qualifications-info {
            max-width: 80%;
            .qualifications-info-text {
            }
        }
    }
}

@include media-breakpoint-down(md) {
    .qualifications-wrapper {
        gap: rem(30);

        .qualifications-buttons {
            max-width: 100%;
        }

        .qualifications-info-wrapper {
            gap: rem(30);
            .qualifications-info {
                max-width: 90%;
                gap: rem(10);

                .qualifications-info-text {
                }
            }
        }
    }
}
</style>
